import { Component, Input } from '@angular/core';

@Component({
  selector: 'ctr-modal-layout',
  imports: [],
  templateUrl: './modal-layout.component.html',
  styleUrl: './modal-layout.component.scss',
})
export class ModalLayoutComponent {
  @Input() title: string | undefined;
}
